class BackInStock extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.$wrapperElement = this.querySelector('.back-in-stock');
    this.$backdropElement = this.querySelector('.back-in-stock__backdrop');
    this.$modalElement = this.querySelector('.back-in-stock__modal');
    this.$backToBrowsing = this.querySelector('.back-to-browsing-btn');
    this.$cancelButton = this.querySelector('.back-in-stock__form-cancel');
    this.$formElement = this.querySelector('.back-in-stock__form');
    this.$formContentElement = this.querySelector('.back-in-stock__form-content');
    this.$inputElement = this.querySelector('.back-in-stock__form-input');
    this.$checkbox = this.querySelector('input[name="marketing-consent"]');
    this.$submitButton = this.querySelector('.back-in-stock__form-submit');

    this.$announcementBar = document.getElementById('shopify-section-announcement-bar');
    this.$header = document.getElementById('shopify-section-header');
    this.$errorElement = this.querySelector('#back-in-stock-error-message');
    this.$successElement = this.querySelector('#back-in-stock-success-message');
    this.$defaultSuccessMessage = this.$successElement.innerHTML;
    this.requestData = {
      a: this.$wrapperElement.dataset.klaviyoKey,
      email: undefined,
      variant: undefined,
      platform: 'shopify',
    };
    this.klaviyoListId = this.querySelector('input[name="klaviyo_list_id"]').value;
    this.$nostoRecommendations = this.querySelector('#custom-notify-me-banner');
    this.$variantInfo = this.querySelector('.back-in-stock__variant-info');
    this.$backInStockText = this.querySelector('.back-in-stock__text');
    this.$marketingConsent = this.querySelector('#marketing-consent');
    this.$continueShoppingButton = this.querySelector('#continue-shopping-button');
    this.$continueShoppingInput = this.querySelector('#continue-shopping-input');
    this.loadNostoRecommendations();
    this.setContinueShoppingEventListenner();
  }

  disconnectedCallback() {
    this.$continueShoppingButton.removeEventListener('click', this.continueShoppingHandler);
  }

  openModal = (event) => {
    try {
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }

      this.classList.remove('hidden');
      this.$successElement.classList.add('hidden');
      this.$inputElement.classList.remove('hidden');
      this.$submitButton.classList.remove('hidden');
      this.$cancelButton.classList.remove('hidden');

      if (this.$announcementBar) {
        this.$announcementBar.classList.add('hidden');
      }
      if (this.$header) {
        this.$header.classList.add('hidden');
      }

      this.$wrapperElement.setAttribute('open', '');
      this.$wrapperElement.setAttribute('aria-hidden', false);
      this.$modalElement.setAttribute('tabindex', 0);
      this.$inputElement.focus();

      this.$backToBrowsing.addEventListener('click', this.closeModal);
      this.$backToBrowsing.addEventListener('ontouchstart', this.closeModal);
      this.$cancelButton.addEventListener('click', this.closeModal);
      this.$cancelButton.addEventListener('ontouchstart', this.closeModal);

      this.$backdropElement.addEventListener('click', this.closeModal);
      this.$backdropElement.addEventListener('ontouchstart', this.closeModal);

      this.$formElement.addEventListener('submit', this.sendForm);

      window.scrollTo(0, 0);
      document.body.classList.add('overflow-hidden');
      document.addEventListener('focus', this.restrictFocus, true);
      document.addEventListener('keydown', this.closeModal);

      this.isOpen = true;
      this.lastFocus = document.activeElement;
      this.showInformationElements();
      this.hideNostoRecommendations();
    } catch (error) {
      console.error(error);
    }
  };

  closeModal = (event) => {
    try {
      if (event.type === 'click') {
        event.stopPropagation();
        event.preventDefault();
      }

      /**
       * make sure to only do something if it's a click
       * on the closing elements, or after pressing Esc key.
       */
      if (
        event.type === 'click' ||
        (event.type === 'keydown' && (event.key === 'Escape' || event.keyCode === 27))
      ) {
        this.classList.add('hidden');
        this.$wrapperElement.removeAttribute('open');
        this.$wrapperElement.setAttribute('aria-hidden', true);
        this.$modalElement.setAttribute('tabindex', '-1');

        if (this.$announcementBar) {
          this.$announcementBar.classList.remove('hidden');
        }
        if (this.$header) {
          this.$header.classList.remove(
            'shopify-section-header-hidden',
            'shopify-section-header-sticky',
            'hidden'
          );
        }

        this.$backToBrowsing.removeEventListener('click', this.closeModal);
        this.$backToBrowsing.removeEventListener('ontouchstart', this.closeModal);
        this.$cancelButton.removeEventListener('click', this.closeModal);
        this.$cancelButton.removeEventListener('ontouchstart', this.closeModal);

        this.$backdropElement.removeEventListener('click', this.closeModal);
        this.$backdropElement.removeEventListener('ontouchstart', this.closeModal);

        this.$formElement.removeEventListener('submit', this.sendForm);

        document.body.classList.remove('overflow-hidden');
        document.removeEventListener('focus', this.restrictFocus, true);
        document.removeEventListener('keydown', this.closeModal);

        this.hideSuccessMessage();
        this.isOpen = false;
        this.lastFocus.focus();
      }
    } catch (error) {
      console.error(error);
    }
  };

  removeButtonLoading = () => {
    this.$submitButton.removeAttribute('disabled');
    this.$submitButton.classList.remove('button--secondary');
    this.$submitButton.classList.remove('loading');
    this.$submitButton.lastElementChild.classList.add('hidden');
  };

  showNostoRecommendations = () => {
    this.$nostoRecommendations.classList.remove('tw-hidden');
  };

  hideNostoRecommendations = () => {
    this.$nostoRecommendations.classList.add('tw-hidden');
  };

  hideInformationElements = () => {
    this.$continueShoppingButton.classList.remove('!tw-hidden');
    this.$variantInfo.classList.add('tw-hidden');
    this.$marketingConsent.classList.add('tw-hidden');
    this.$backInStockText.classList.add('tw-hidden');
  };

  showInformationElements = () => {
    this.$continueShoppingButton.classList.add('!tw-hidden');
    this.$variantInfo.classList.remove('tw-hidden');
    this.$marketingConsent.classList.remove('tw-hidden');
    this.$backInStockText.classList.remove('tw-hidden');
  };

  sendForm = async (event) => {
    try {
      event.preventDefault();

      const email = this.$inputElement.value;
      if (
        !email.match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
      ) {
        this.showErrorMessage();
        return;
      }

      if (!this.requestData.variant) {
        const addToBagButton = document.getElementById('add-to-bag');
        const variantId = +addToBagButton.dataset?.variantId;
        if (variantId) {
          this.setVariantId(variantId);
        } else {
          throw new Error('A variant must be defined.');
        }
      }
      this.hideErrorMessage();
      this.requestData.email = email;
      this.$submitButton.setAttribute('disabled', '');
      this.$submitButton.classList.add('button--secondary');
      this.$submitButton.classList.add('loading');
      this.$submitButton.lastElementChild.classList.remove('hidden');

      const body = {
        email,
        variantId: `${this.requestData.variant}`,
        klaviyo: { listId: this.klaviyoListId },
        marketingConsent: this.$checkbox.checked,
      };

      const response = await Backend.backInStock(body);
      const klaviyoErrorMessage = response.data?.klaviyo?.error;
      const shopifyErrorMessage = response.data?.shopify?.error;
      const backInStockErrorMessage = response.data?.backInStock?.error;

      if (klaviyoErrorMessage) {
        this.showSubmitMessage(klaviyoErrorMessage, true);
        return;
      }

      if (shopifyErrorMessage) {
        this.showSubmitMessage(shopifyErrorMessage, true);
        return;
      }

      if (backInStockErrorMessage) {
        this.showSubmitMessage(backInStockErrorMessage, true);
        return;
      }

      this.dispatchBackInStockEvent();
      this.removeButtonLoading();
      this.showSubmitMessage();
      this.hideInformationElements();
      this.showNostoRecommendations();
    } catch (error) {
      this.showSubmitMessage(error?.message || 'Fail in subscription, try again later', true);
    }
  };

  dispatchBackInStockEvent() {
    const eventName = window.FarmRio?.events?.backInStockFormSubscribed;
    if (eventName) {
      document.dispatchEvent(new Event(eventName));
    }
  }

  showSubmitMessage = (message = this.$defaultSuccessMessage, errorLike = false) => {
    try {
      if (message !== this.$defaultSuccessMessage) {
        this.$successElement.innerHTML = message;
      }

      if (errorLike) {
        this.$successElement.classList.add('back-in-stock__message--error');
        this.$successElement.classList.remove('back-in-stock__message--success');
      }

      this.$successElement.classList.remove('hidden');
      this.$inputElement.classList.add('hidden');
      this.$submitButton.classList.add('hidden');
      this.$cancelButton.classList.add('hidden');

      this.$inputElement.setAttribute('aria-describedby', 'back-in-stock-success-message');
    } catch (error) {
      console.error(error);
    }
  };

  hideSuccessMessage = () => {
    try {
      this.$successElement.classList.add('hidden');

      if (this.$successElement.innerHTML !== this.$defaultSuccessMessage) {
        this.$successElement.innerHTML = this.$defaultSuccessMessage;
      }

      if (!this.$successElement.classList.contains('back-in-stock__message--success')) {
        this.$successElement.classList.add('back-in-stock__message--success');
      }

      this.$inputElement.removeAttribute('aria-describedby');
    } catch (error) {
      console.error(error);
    }
  };

  showErrorMessage = () => {
    try {
      this.$errorElement.classList.remove('hidden');

      this.$inputElement.setAttribute('aria-invalid', true);
      this.$inputElement.setAttribute('aria-describedby', 'back-in-stock-error-message');
      this.$inputElement.focus();
    } catch (error) {
      console.error(error);
    }
  };

  hideErrorMessage = () => {
    try {
      this.$errorElement.classList.add('hidden');

      this.$inputElement.removeAttribute('aria-invalid');
      this.$inputElement.removeAttribute('aria-describedby');
    } catch (error) {
      console.error(error);
    }
  };

  restrictFocus = (event) => {
    try {
      if (this.isOpen && !this.$modalElement.contains(event.target)) {
        event.stopPropagation();
        this.$modalElement.focus();
      }
    } catch (error) {
      console.error(error);
    }
  };

  setVariantId = (variantId) => (this.requestData.variant = variantId);

  loadNostoRecommendations = () => {
    const props = {
      productCardClassMap: {
        'add-to-bag-component': 'tw-hidden',
        '[data-test-sale-compare_at_price]': '!tw-text-sm',
        '.card-information': 'tw-mt-2',
        '.card-information__text': 'tw-text-xs tw-font-normal tw-capitalize',
        '.shelf-selector': 'tw-hidden',
        'product-card div:nth-of-type(2)': '!tw-p-0',
        '[data-test-id="card-information"]': '!tw-pl-1',
        '[data-add-to-bag-component-button]': ' !tw-p-0 !tw-block !tw-pl-1',
        '.price div:nth-of-type(1)': 'tw-text-xs',
      },
      placementName: 'notify-me-banner',
    };
    window.FarmRio.React.queue.add({
      rootID: 'custom-notify-me-banner',
      component: 'organisms/nosto-recommendations',
      props,
    });
  };

  continueShoppingHandler = () => {
    const previousUrl = sessionStorage.getItem('previousUrl');
    const redirectUrl = this.$continueShoppingInput?.value;

    if (previousUrl && previousUrl.includes('#product-grid-item')) {
      window.history.back();
    } else {
      window.location.href = redirectUrl;
    }
    sessionStorage.removeItem('previousUrl');
  };

  setContinueShoppingEventListenner = () => {
    this.$continueShoppingButton.addEventListener('click', this.continueShoppingHandler);
  };
}
customElements.define('back-in-stock', BackInStock);
const emailInput = document.querySelector('.back-in-stock__form-input');
const notifyMeSubmitBtn = document.querySelector('.back-in-stock__form-submit');

emailInput.addEventListener('input', () => {
  if (emailInput.validity.valid) {
    notifyMeSubmitBtn.disabled = false;
  } else {
    notifyMeSubmitBtn.disabled = true;
  }
});
